<template>
 <span v-if="value" class="date-value">
    {{ dateString }}
  </span>
  <span v-else>
    -
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      required: false,
      default: null
    },
    monthString: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    dateString () {
      if(this.monthString) {
        return this.$formatDateString(this.value)
      }
      return this.$formatDateStandard(this.value)
    }
  }
}
</script>
